import { ImportCSVTableFieldModel } from "./ImportCSV";
import Style from 'ol/style/Style';
import VectorSource from 'ol/source/Vector';
import Icon from 'ol/style/Icon';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import { Circle } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import { Layer, VectorLayerDMTR } from "../menu/view-menu/layer";



export class ProcessingToolCSVModel {
  table : ImportCSVTableFieldModel[] = [];
  fieldSeparator : string = ";";
  decimalSeparator : string = ".";
  fileName: string = "";
  processingTool_attributes: any[];

  fillTable() : void {
    this.table.push(new ImportCSVTableFieldModel("Latitude" ,"1", false, true, "[Deg]"));
    this.table.push(new ImportCSVTableFieldModel("Longitude" ,"2", false, true, "[Deg]"));
    let counter = 3;
    for (const attribute of this.processingTool_attributes){
        this.table.push(new ImportCSVTableFieldModel(attribute.displayName ,counter.toString(), false, true, attribute.units));
        counter++;
    }
  }

  getCSVFileHeader(): string[]{
    const toReturnHeaders: string[] = [];
    for (const field of this.table){
        field.checked? toReturnHeaders.push(field.name): false;
    }
    return toReturnHeaders;
  }

}